import { createPagination } from '~/shared/lib/pagination';

export const payinTicketPaginationModel = createPagination();
export const payoutTicketPaginationModel = createPagination();
